import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

import { FilterComponent } from './filter.component';

@NgModule({
  imports: [CommonModule, FormsModule, MatCardModule, MatButtonModule, MatDatepickerModule, MatNativeDateModule, MatIconModule, MatInputModule],
  declarations: [FilterComponent],
  exports: [FilterComponent]
})
export class FilterModule {}
